import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAcUeeHfwqB8J6hOsrz9e8Lre_zIt7r0UY",
  authDomain: "debilnicek-15f31.firebaseapp.com",
  projectId: "debilnicek-15f31",
  storageBucket: "debilnicek-15f31.firebasestorage.app",
  messagingSenderId: "109953915981",
  appId: "1:109953915981:web:861085887d57d738671004"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
